if (window.Handlebars) {
	Handlebars.registerHelper("dateFormat", function(obj) {
		if (!obj) return obj;
		var date = obj.split("-");
		var result = date[2] + "/" + date[1] + "/" + date[0];
		return new Handlebars.SafeString(result);
	});
}


// WEBPACK FOOTER //
// ./../../../rairadio/template/helpers/date-format-helper.js